module.exports = __webpack_public_path__ + "img/38ac9.206d8c05.svg";